// Assistance Form Hs
document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("popupModalx")) {
        const modal = document.getElementById("popupModalx");
        const trigger = document.querySelector(".assistmain");
        const formContainer = document.getElementById("hs-formx");
        const closeButton = document.querySelector(".close-btnx");

        let formSubmitted = false;

        trigger.addEventListener("click", function () {
            modal.style.display = "flex";
            document.body.classList.add("modal-openx");
        });

        modal.addEventListener("click", function (event) {
            if (event.target === modal) closeModal();
        });

        function closeModal() {
            modal.style.display = "none";
            document.body.classList.remove("modal-openx");
            if (formSubmitted) location.reload();
        }

        const observer = new MutationObserver(function (mutationsList) {
            mutationsList.forEach(mutation => {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(node => {
                        if (node.classList && node.classList.contains("submitted-message")) {
                            formSubmitted = true;
                        }
                    });
                }
            });
        });

        observer.observe(formContainer, { childList: true, subtree: true });
        closeButton.addEventListener("click", closeModal);
    }
});

// Be the First to know
document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("popupModalx-first-to")) {
        const modalNextPop = document.getElementById("popupModalx-first-to");
        const formContainerNextPop = document.getElementById("hs-formx-first-to");
        const closeButtonNextPop = document.querySelector(".close-btnx-first-to");
        const teaser = document.querySelector(".cs-teaser");
        const teaserClose = document.querySelector(".cs-teaser-close");

        let formSubmitted = false;

        function setCookie(name, value, days) {
            let expires = "";
            if (days) {
                let date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
        }

        function getCookie(name) {
            let nameEQ = name + "=";
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

        function openModalNextPop() {
            if (!modalNextPop) return;
            modalNextPop.style.display = "flex";
            document.body.classList.add("modal-openx");
        }

        function closeModalNextPop() {
            if (!modalNextPop) return;
            modalNextPop.style.display = "none";
            document.body.classList.remove("modal-openx");

            // store cookie so popup won't auto-open again
            setCookie('modalClosed', 'true', 7);

            // show teaser so user can reopen popup manually on other pages/reloads
            if (teaser) teaser.style.display = "flex";

            if (formSubmitted) {
                setTimeout(() => {
                    location.reload();
                }, 4000);
            }
        }
        // expose globally so inline onclick handlers (close X and "continue to the site") work
        window.closeModalNextPop = closeModalNextPop;

        // make closeTeaser available globally so you can call it from HTML onclick
        window.closeTeaser = function (event) {
            // optional event (if passed from HTML onclick), stop propagation so parent click won't fire
            if (event && typeof event.stopPropagation === "function") {
                event.stopPropagation();
            }
            if (teaser) {
                teaser.style.display = "none";
            }
        };

        // If cookie present, do NOT auto-open modal; show teaser instead.
        // Otherwise open after the visitor has had a chance to browse:
        // whichever comes first -- a 15s timer OR scrolling down the page.
        if (!getCookie('modalClosed')) {
            window.addEventListener('load', () => {
                let popOpened = false;
                function triggerNextPop() {
                    if (popOpened) return;
                    popOpened = true;
                    window.removeEventListener('scroll', onNextPopScroll);
                    openModalNextPop();
                }
                function onNextPopScroll() {
                    if (window.scrollY > 600) triggerNextPop();
                }
                window.addEventListener('scroll', onNextPopScroll, { passive: true });
                setTimeout(triggerNextPop, 15000);
            });
        } else {
            if (teaser) teaser.style.display = "none";
        }

        // Close when clicking outside modal
        if (modalNextPop) {
            modalNextPop.addEventListener("click", function (event) {
                if (event.target === modalNextPop) closeModalNextPop();
            });
        }

        // Observe form submission (mutation of "submitted-message")
        if (formContainerNextPop) {
            const observer = new MutationObserver(function (mutationsList) {
                mutationsList.forEach(mutation => {
                    if (mutation.addedNodes.length) {
                        mutation.addedNodes.forEach(node => {
                            if (node.classList && node.classList.contains("submitted-message")) {
                                formSubmitted = true;
                                setCookie('modalClosed', 'true', 7);
                                // show teaser after submission (so popup won't auto-open but teaser is available)
                                if (teaser) teaser.style.display = "none";
                            }
                        });
                    }
                });
            });

            observer.observe(formContainerNextPop, { childList: true, subtree: true });
        }

        // Close button inside modal
        if (closeButtonNextPop) closeButtonNextPop.addEventListener("click", closeModalNextPop);

        // Clicking teaser re-opens modal
        if (teaser) {
            teaser.addEventListener("click", function () {
                openModalNextPop();
            });
        }
    }
});

// Ntfy me Popup
document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("popupModalNtfy")) {
        const modal = document.getElementById("popupModalNtfy");
        const trigger = document.querySelector("#notifyBtn");
        const formContainer = document.getElementById("hs-formNtfy");
        const closeButton = document.querySelector(".close-btnNtfy");

        let formSubmitted = false;

        trigger.addEventListener("click", function () {
            modal.style.display = "flex";
            document.body.classList.add("modal-openx");
        });

        modal.addEventListener("click", function (event) {
            if (event.target === modal) closeModal();
        });

        function closeModal() {
            modal.style.display = "none";
            document.body.classList.remove("modal-openx");
            if (formSubmitted) location.reload();
        }

        const observer = new MutationObserver(function (mutationsList) {
            mutationsList.forEach(mutation => {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(node => {
                        if (node.classList && node.classList.contains("submitted-message")) {
                            formSubmitted = true;
                        }
                    });
                }
            });
        });

        observer.observe(formContainer, { childList: true, subtree: true });
        closeButton.addEventListener("click", closeModal);
    }
});

// Trade Side Popup
document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("popupModalx-trade")) {
        const modal = document.getElementById("popupModalx-trade");
        const trigger = document.querySelector("#cs-tradepop-submit");
        const formContainer = document.getElementById("hs-formx-trade");
        const closeButton = document.querySelector(".close-btnx-trade");

        let formSubmitted = false;

        trigger.addEventListener("click", function () {
            modal.style.display = "flex";
            document.body.classList.add("modal-openx");
        });

        modal.addEventListener("click", function (event) {
            if (event.target === modal) closeModal();
        });

        function closeModal() {
            modal.style.display = "none";
            document.body.classList.remove("modal-openx");
            if (formSubmitted) {
                setTimeout(() => {
                    location.reload();
                }, 4000);
            }
        }

        const observer = new MutationObserver(function (mutationsList) {
            mutationsList.forEach(mutation => {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(node => {
                        if (node.classList && node.classList.contains("submitted-message")) {
                            formSubmitted = true;
                        }
                    });
                }
            });
        });

        observer.observe(formContainer, { childList: true, subtree: true });
        closeButton.addEventListener("click", closeModal);
    }
});

// Trade Main trigger
let close = document.getElementById('cs-tradepop-close');
let popup = document.getElementById('cs-trade-popup');
let submit = document.getElementById('cs-tradepop-submit');

function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function hidePopup() {
    popup.style.transform = 'translate(115%)';
    setCookie('popupClosed', 'true', 7);
}

if (close) close.addEventListener('click', hidePopup);
if (submit) submit.addEventListener('click', hidePopup);

window.addEventListener('load', () => {
    if (!getCookie('popupClosed') && popup) {
        setTimeout(() => {
            popup.style.transform = 'unset';
        }, 30000);
    }
});
